
















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Account from "@/lib/models/BankAccount";
import User from "@/lib/models/User";
import {chunkString} from "@/lib/functions";

@Component({})
export default class EditModal extends Vue {
    private $firebase: any;

    @Prop() paymentAccount?: Account;
    @Prop() user?: User;
    @Prop() collection?: firebase.database.ThenableReference;

    @Watch('paymentAccount')
    onChildChanged(val: Account, oldVal: Account) {
        console.log(val);
        this.paymentAccountToEdit = (new Account()).fromObject(val) as Account;
    }

    paymentAccountToEdit: Account | null = null;
    isOpen: boolean = false;

    toggle() {
        this.isOpen = !this.isOpen
    }

    formatIban() {
        if (this.paymentAccountToEdit && this.paymentAccountToEdit.iban) {
            const iban = this.paymentAccountToEdit.iban.replace(/\W/g, '');
            // @ts-ignore
            this.paymentAccountToEdit.iban = chunkString(iban, 4).join(' ');
        }
    }

    submitForm() {
        if (this.$refs.submitButton) {
            (this.$refs.submitButton as HTMLButtonElement).click();
        }
    }

    saveAccount() {

        if (this.paymentAccountToEdit && this.user && this.paymentAccount) {
            const updates: { [k: string]: Account } = {};
            updates[`account/${this.user.uid}/${this.paymentAccount.id}`] = this.paymentAccountToEdit;

            this.$firebase.database().ref().update(updates);
        }
    }
}
